import { render, staticRenderFns } from "./RequestChangesBar.vue?vue&type=template&id=afae7800&scoped=true&"
import script from "./RequestChangesBar.vue?vue&type=script&lang=js&"
export * from "./RequestChangesBar.vue?vue&type=script&lang=js&"
import style0 from "./RequestChangesBar.vue?vue&type=style&index=0&id=afae7800&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afae7800",
  null
  
)

export default component.exports